import { AppError } from './AppError'

export class ExternalServiceError extends AppError {
  constructor(
    message: string,
    public readonly serviceName: string,
    public readonly statusCode?: number,
    public readonly requestPath?: string,
    options?: ErrorOptions,
  ) {
    super(message, 'EXTERNAL_SERVICE_ERROR', { serviceName, statusCode, requestPath }, options)
    this.name = 'ExternalServiceError'
  }

  toLogContext() {
    return {
      ...super.toLogContext(),
      serviceName: this.serviceName,
      statusCode: this.statusCode,
      requestPath: this.requestPath,
    }
  }
}
